"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonTileGrid = void 0;
const React = require("react");
const Spinner_1 = require("../Spinner");
const BronsonTileGrid = ({ data }) => {
    const configSpinner = {
        showSpinner: true,
        spinnerWrapperClassModifier: 'c-spinner--center',
    };
    const wrapperCenter = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };
    return (React.createElement("div", { className: 'c-tile-grid' }, data.map((item, index) => {
        const href = item.href;
        const isLoading = item.isLoading;
        if (isLoading) {
            return (React.createElement("div", { key: index, style: wrapperCenter, className: `c-tile-grid__item ${item.twoColumns
                    ? 'c-tile-grid__item--large'
                    : ''}` },
                React.createElement(Spinner_1.BronsonSpinner, { config: configSpinner })));
        }
        return (React.createElement("div", { key: index, className: `c-tile-grid__item ${item.twoColumns ? 'c-tile-grid__item--large' : ''}` },
            React.createElement("a", Object.assign({ id: item.id, className: 'c-tile' }, (item.href ? { href } : {}), { onClick: item.onClick }),
                item.image && (React.createElement("img", { className: `c-tile__image  js-object-fit ${item.centerImage
                        ? 'u-focus-point-center-right'
                        : ''}`, src: item.image, alt: item.altImage })),
                React.createElement("div", { className: 'c-tile__content' },
                    item.title && (React.createElement("h5", { className: 'c-tile__pre-title' }, item.title)),
                    item.description && (React.createElement("h4", { className: 'c-tile__title' }, item.description))))));
    })));
};
exports.BronsonTileGrid = BronsonTileGrid;
